export const mainCls = 'pill-button';

export default {
  [mainCls]: {
    cursor: 'pointer',
    borderRadius: '20px',
    
  },
  [`${mainCls}__cnt-btns`]: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre',
  },
  [`${mainCls}__default`]: {
    border: 'solid 1px #d8dbdf',
    backgroundColor: '#fff',
    '&:hover': {
      border: 'solid 1px #1a1f24',
    },
    '&:active': {
      border: 'solid 1px #1a1f24',
      backgroundColor: '#96a1b0',
      '& span': {
        color: '#f0f2f5',
      }
    }
  },
  [`${mainCls}__secondary`]: {
    border: 'solid 1px #d8dbdf',
    backgroundColor: '#39434e',
    color: '#fff !important',
    '&:hover': {  
      backgroundColor: '#252b33',
    },
    '&:active': {
      backgroundColor: '#505a65',
      
    }
  },
};